import React, { Component } from 'react';
import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import _ from 'underscore';
import { getSortedReasonCodes } from 'utils/ReasonCodesAPI';
import { withTranslation } from 'react-i18next';
import { addlocalizationSlugKey } from 'utils/localization/utils';
class SelectReasonCodes extends Component {
    constructor(props) {
        super(props);
        this.getCustomReasonCodes = async (shipperId, shipment_type, category) => {
            try {
                const codes = await getSortedReasonCodes(shipperId, shipment_type, category);
                if (!codes || !codes.subCategories || !codes.subCategories.length) {
                    return null;
                }
                const { subCategories, requireCodes } = codes;
                const reasonTypes = subCategories.map((s) => {
                    return { name: s.reasonType, value: s.reasonType };
                });
                this.setState({ reasonTypes, subCategories, requireCodes });
                if (this.props.setCodesRequired) {
                    this.props.setCodesRequired(requireCodes);
                }
            }
            catch (e) {
                console.log('Error fetching custom reason codes', e);
            }
        };
        this.handleCommentInput = (comment) => {
            this.setState({ comment });
            this.props.updateComment(comment);
        };
        this.handleReasonTypeSelect = (item) => {
            const { subCategories } = this.state;
            const subCategory = subCategories.find((s) => s.reasonType === item.value);
            this.setState({
                selectedReasonType: item.value,
                commentRequired: subCategory === null || subCategory === void 0 ? void 0 : subCategory.commentRequired,
                reasonCodes: (subCategory === null || subCategory === void 0 ? void 0 : subCategory.reasonCodes) || [],
            });
            this.props.updateCommentRequired(subCategory.commentRequired);
        };
        this.handleReasonCodeSelect = (item) => {
            const selectedReasonCode = item.code !== '' ? item.code : item.description;
            this.setState({ selectedReasonCode });
            const selectedItemWithType = _.assign(item || {}, {
                reasonType: this.state.selectedReasonType,
            });
            this.props.selectReasonCode(selectedItemWithType);
        };
        this.state = {
            subCategories: [],
            reasonCodes: [],
            reasonTypes: [],
            selectedReasonCode: null,
            selectedReasonType: null,
            commentRequired: false,
            comment: '',
            requireCodes: false,
        };
    }
    async componentDidMount() {
        const { category, shipment } = this.props;
        await this.getCustomReasonCodes(shipment.shipper._id, shipment.shipment_type, category);
    }
    renderReasonCodeComment() {
        const { comment } = this.state;
        const { t } = this.props;
        return (React.createElement(CargomaticInput, { dataTestId: "CargomaticInput-29f61462", className: "w-2/3 mt-4", label: t('REASON_CODE_COMMENT'), type: "text", info: t('REASON_CODE_REQUIRED_COMMENT'), value: comment, onChange: this.handleCommentInput }));
    }
    render() {
        const { reasonTypes, reasonCodes, selectedReasonCode, selectedReasonType, commentRequired, subCategories, requireCodes, } = this.state;
        const { t } = this.props;
        if (!subCategories || !reasonTypes || !reasonCodes) {
            return (React.createElement("span", { "data-testid": "span-ba5e3351" }, t('NO_REASON_CODES_FOUND')));
        }
        return (React.createElement("div", { "data-testid": "div-c1dae138", className: "relative w-full" },
            React.createElement("div", { "data-testid": "div-81f12897", className: "flex flex-row" }, requireCodes && (React.createElement("span", { "data-testid": "span-e2d7f720", className: "mt-2 mb-2 italic" }, t('REASON_CODE_REQUIRED')))),
            React.createElement("div", { "data-testid": "div-0f8bad0f", className: "flex flex-col" },
                React.createElement("div", { "data-testid": "div-8ff2a400", className: "w-2/3" },
                    React.createElement(CargomaticSelect, { dataTestId: "CargomaticSelect-791dd690", className: "w-full", inputClassNames: "w-full", label: t('REASON_TYPE'), info: t('REASON_TYPE_INFO'), caption: t('REASON_TYPE_CAPTION'), items: addlocalizationSlugKey(reasonTypes, 'name'), valueKey: "value", textKey: "localizationSlug", value: selectedReasonType, onSelect: this.handleReasonTypeSelect })),
                React.createElement("div", { "data-testid": "div-5dca8b12", className: "w-2/3 mt-4" },
                    React.createElement(CargomaticSelect, { dataTestId: "CargomaticSelect-f7cb1813", className: "w-full", inputClassNames: "w-full", label: t('REASON_CODE'), info: t('SELECT_REASON_CODE'), caption: t('SELECT_REASON_CODE'), items: addlocalizationSlugKey(reasonCodes, 'description'), showCaption: true, valueKey: this.props.useDescriptionAsValue ? 'description' : 'code', textKey: "localizationSlug", value: selectedReasonCode, onSelect: this.handleReasonCodeSelect }))),
            commentRequired && this.renderReasonCodeComment()));
    }
}
export default withTranslation()(SelectReasonCodes);
